import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import {
  CustomerAddresses,
  CustomerAddress,
  CreateCustomerAddress,
  UpdateCustomerAddress,
} from "./pages";

export const CustomerAddressesRouter = [
  <Route
    path="/customer-addresses"
    element={
      <ProtectedRoute roles={["Any"]}>
        <CustomerAddresses />
      </ProtectedRoute>
    }
  />,

  <Route path="/customer-address">
    <Route
      path="create"
      element={
        <ProtectedRoute roles={["Any"]}>
          <CreateCustomerAddress />
        </ProtectedRoute>
      }
    />
    <Route
      path=":id"
      element={
        <ProtectedRoute roles={["Any"]}>
          <CustomerAddress />
        </ProtectedRoute>
      }
    />
    <Route
      path=":id/update"
      element={
        <ProtectedRoute roles={["Any"]}>
          <UpdateCustomerAddress />
        </ProtectedRoute>
      }
    />
  </Route>,
];
